import React from 'react';
import styles from './RelatedReportsTab.module.css';

interface RelatedReportsTabProps {
    reports?: any[];
}

const RelatedReportsTab: React.FC<RelatedReportsTabProps> = ({ reports }) => {
    if (!reports || reports.length === 0) {
        return <div className={styles.emptyState}>No related reports found.</div>;
    }

    const truncateWords = (text: string, wordLimit: number) => {
        if (!text) return '';
        const words = text.split(/\s+/);
        if (words.length <= wordLimit) return text;
        return words.slice(0, wordLimit).join(' ') + '...';
    };

    return (
        <div className={styles.tabContent}>
            <div className={styles.gridContainer}>
                {reports.slice(0, 8).map((report, index) => (
                    <div key={index} className={styles.gridItem}>
                        <a href={`/report/${report.slug}`} className={styles.reportLink}>
                            <h3 className={styles.reportTitle}>
                                {report.title}
                                {report.summary && <span className={styles.reportSummary}> - {truncateWords(report.summary, 12)}</span>}
                            </h3>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RelatedReportsTab;
